<template>
  <v-card class="my-6 pa-6">
    Featured Guilds
  </v-card>
</template>

<script>
export default {
  name: 'FeaturedGuilds',
}
</script>

<style lang="scss" scoped>
</style>